// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"448":"6523147d","453":"e60b9ba9","517":"380571ed","835":"e2402a53"}[chunkId] + ".chunk.js";
};